export enum AutoBookStep {
  INFO_AND_PHONE = 'INFO_AND_PHONE',
  THEATER_SELECTION = 'THEATER_SELECTION',
  VIEW_EXISTING_PREFERENCES = 'VIEW_EXISTING_PREFERENCES',
  CONFIRMATION = 'CONFIRMATION',
}

export interface AutoBookModalProps {
  open: boolean
  onClose: () => void
}
